import { createContext, useContext, useMemo, useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useServicePeriods } from '../../hooks'; // ← useServicePeriods(tenant_id,user_key)

const DashboardCtx = createContext(null);
export const useDashboard = () => useContext(DashboardCtx);

export function DashboardProvider({ children, defaultYear, defaultMonth }) {
    const { user } = useAuth();
    const tenantId = user?.tenant_id;
    const userKey = user?.user_key;

    const { data: periods } = useServicePeriods(tenantId, user.role === 'ADMIN' ? 0 : userKey);
    const years = periods?.years ?? [];
    const monthsByYear = periods?.monthsByYear ?? {};
    const latestYear = periods?.latestYear;
    const latestMonth = periods?.latestMonth;

    // 기본 선택값
    const now = new Date();
    const curYear = now.getFullYear();
    const curMonth = String(now.getMonth() + 1).padStart(2, '0');

    const [year, setYear] = useState(latestYear ?? curYear);
    const [month, setMonth] = useState(latestMonth ?? curMonth);

    // periods가 로드되면 최신값으로 1회 보정
    useEffect(() => {
        if (latestYear && latestMonth) {
            setYear(latestYear);
            setMonth(latestMonth);
        }
    }, [latestYear, latestMonth]);

    // 연도 변경 시 해당 연도의 유효 월로 보정 (monthsByYear 제공 시)
    useEffect(() => {
        const valid = monthsByYear[year];
        if (Array.isArray(valid) && valid.length > 0) {
            if (!valid.includes(month)) {
                setMonth(valid[valid.length - 1]); // 그 연도의 가장 최근 월
            }
        } else {
            // 서버가 월 목록을 주지 않는 연도면, 올해 초과 방지(기존 로직 유지)
            if (Number(year) === curYear && Number(month) > Number(curMonth)) {
                setMonth(curMonth);
            }
        }
    }, [year, monthsByYear]); // month는 내부에서 보정

    const value = useMemo(
        () => ({
            year,
            month,
            setYear,
            setMonth,
            years,
            monthsByYear,
            curYear,
            curMonth,
        }),
        [year, month, years, monthsByYear, curYear, curMonth]
    );
    return <DashboardCtx.Provider value={value}>{children}</DashboardCtx.Provider>;
}
